import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export type TicketStatusStage =
  | 'intake'
  | 'in_progress'
  | 'waiting'
  | 'ready'
  | 'closed'
  | 'cancelled';

export type TicketStatusRecord = {
  id: string;
  tenantId: string;
  storeId: string | null;
  name: string;
  slug: string;
  color: string;
  icon: string | null;
  stage: TicketStatusStage | string;
  sortOrder: number;
  active: boolean;
  isSystem: boolean;
  triggersSms: boolean;
  triggersEmail: boolean;
  smsTemplate: string | null;
  createdAt: string;
};

export type CreateTicketStatusInput = {
  name: string;
  slug?: string;
  color?: string;
  icon?: string | null;
  stage: TicketStatusStage;
  sortOrder?: number;
  triggersSms?: boolean;
  triggersEmail?: boolean;
  smsTemplate?: string | null;
  storeId?: string | null;
};

export type PatchTicketStatusInput = Partial<CreateTicketStatusInput> & {
  active?: boolean;
  acknowledgeStageChange?: boolean;
};

export function listTicketStatuses(opts?: { includeInactive?: boolean }) {
  const qs = opts?.includeInactive ? '?includeInactive=true' : '';
  return apiGet<TicketStatusRecord[]>(`/api/v1/ticket-statuses${qs}`).then((r) => r.data);
}

export function createTicketStatus(body: CreateTicketStatusInput) {
  return apiPost<TicketStatusRecord>('/api/v1/ticket-statuses', body).then((r) => r.data);
}

export function patchTicketStatus(id: string, body: PatchTicketStatusInput) {
  return apiPatch<TicketStatusRecord>(`/api/v1/ticket-statuses/${id}`, body).then((r) => r.data);
}

export function reorderTicketStatuses(orderedIds: string[]) {
  return apiPatch<{ ok: boolean }>('/api/v1/ticket-statuses/reorder', { orderedIds }).then(
    (r) => r.data,
  );
}

export function deleteTicketStatus(id: string) {
  return apiDelete(`/api/v1/ticket-statuses/${id}`);
}
